/**
 * 操作ログの内容判定ユーティリティ
 * testCases が配列かつ pages が配列であれば操作ログとみなす
 */

function is_record(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

/**
 * 渡された値が操作ログ形式（testCases と pages が配列）かどうかを判定する
 */
export function is_operation_log_content(value: unknown): boolean {
  if (!is_record(value)) {
    return false;
  }
  if (!Array.isArray(value.testCases)) {
    return false;
  }
  return Array.isArray(value.pages);
}

/** 操作ログでない場合のメインエラーメッセージ */
export const OPERATION_LOG_INVALID_MESSAGE =
  "アップロードされたファイルが操作ログではありません。";

/** 操作ログ形式の詳細案内 */
export const OPERATION_LOG_FORMAT_GUIDANCE =
  "操作ログは\"testCases\"、\"pages\"のデータがあるjson形式のファイルです。";
